/**
 * Handles the loading and display of the entire menu
 *
 * Injections:
 *   $menuService: to get the menus to display and check for out of stock items
 *   $anchorScroll: for scrolling
 *   $location: for scrolling
 */
export function MenuController($rootScope, $scope, $state, menuService, $anchorScroll, $location, itemStatusChannel,
    cartDisplayService, cartStatusChannel, restaurantInfoFactory, googleAnalyticsTrackingService) {
    'ngInject';
    $scope.menuFlags = {
        // Flag to show/hide spinner
        loading: true
    };
    $scope.selectItem = selectItem;
    $scope.scrollTo = scrollTo;
    $scope.loadMenus = loadMenus;
    $scope.isItemOos = isItemOos;
    $scope.getHasSpotlight = getHasSpotlight;
    /**
    * Stores the JSON object for the entire menu, not including modifiers.
    *  -> will be a reference to the menus in menuService
    */
    $scope.menus = [];
    $scope.oosItems = [];

    $scope.menuGroupSelectionEvent = googleAnalyticsTrackingService.getMenuGroupSelectionEvent();
    $scope.menuItemSelectionEvent = googleAnalyticsTrackingService.getMenuItemSelectionEvent();

    activate();
    //---------

    function activate() {
        restaurantInfoFactory.getInfo(['imageSet', 'onlineOrder'])
            .then(info => {
                $scope.restaurantInfo = info;
                $scope.enableOO = info.onlineOrder.isOnlineOrderingEnabled;
            });

        cartStatusChannel.onConfiguredCart($scope, $scope.loadMenus);

        // Need to open the correct tab initially.
        openTabForState($state.current);
        $scope.isCartOpen = $state.current.name === 'order.cart';

        // As well as when the state changes.
        // TODO This shouldn't be necessary once we split up the template.
        $rootScope.$on('$stateChangeSuccess', function(event, toState) {
            $scope.isCartOpen = toState.name === 'order.cart';
            openTabForState(toState);
        });

        _triggerInitialMenuLoad();
    }

    //Removes the dependency on having a <cart> element on the page in order to load the menus
    function _triggerInitialMenuLoad() {
        cartDisplayService.getDisplayData().finally(() => {
            if (cartDisplayService.displayData.fulfillmentMoment) {
                cartStatusChannel.configuredCart(cartDisplayService.displayData.fulfillmentMoment.format());
            }
            else {
                cartStatusChannel.configuredCart(null);
            }
        });
    }

    function getHasSpotlight() {
        return (
            $scope.restaurantInfo && (
                $scope.restaurantInfo.imageSet.spotlight.url ||
                $scope.restaurantInfo.onlineOrder.spotlightText
            )
        );
    }

    function openSpotlightTab() {
        $scope.setActiveTab($scope.tabs.spotlight);
    }

    function openMenuTab() {
        $scope.setActiveTab($scope.tabs.menu);
    }

    /**
     * selectItem(): broadcasts an event to child controllers (in this case modifierDialogController)
     *  -> signals the child controller to display the modifiers dialog
     *  -> we need to do this because the child controller has its own scope
     */
    function selectItem(group, item) {
        if (item.inventoryCount !== 0 && !isItemOos(item)) {
            itemStatusChannel.selectItem({
                group: group,
                item: item
            });
        }
    }

    /**
     * Scrolls to the specified element id on the menu, either a menu header or group header
     * @param id
     */
    function scrollTo(id) {
        // Since the menu scrollbar is for the entire page, we need to compensate for the fixed header
        $anchorScroll.yOffset = 150;

        var old = $location.hash();

        $location.hash(id);
        // This will scroll to the given id
        $anchorScroll();

        /**
         * Since $location is used for angular routing, the first click on an anchor link
         * will add a #/ to the url, preventing the anchor from working.
         *
         * To avoid this we manually scroll to the id, and then reset the location has
         * so that angular routing does not kick in.
         *
         * The side effect to this is that the URL will not change when anchors are clicked
         *
         * Link to issue: https://github.com/angular/angular.js/issues/460
         * Link to solution: http://stackoverflow.com/a/15935517
         */
        $location.hash(old);
    }

    /**
     * Loads menus based on a fulfillmentDate
     * @param fulfillmentDate
     */
    function loadMenus(fulfillmentDate) {
        $scope.menuFlags.loading = true;

        menuService.getMenus(fulfillmentDate)
            .then(function(menus) {
                $scope.menus = menus;
                $scope.menuFlags.loading = false;

                return menuService.validateItemStock();
            })
            .then(function(oosItems) {
                $scope.oosItems = oosItems;
            });
    }

    function isItemOos(item) {
        return cartDisplayService.displayData.isOrderForToday && $scope.oosItems.includes(item.idString);
    }

    function openTabForState(state) {
        switch (state.name) {
        case 'order.spotlight':
            openSpotlightTab();
            break;

        case 'order':
            openMenuTab();
            break;

        default: // no-op
        }
    }
}
